import React, { FC } from 'react'

import { DismissibleCardItem } from '@smarty-nx/contentful'

import classes from './banners-carousel.module.scss'
import { Tile } from './tile/tile'
import { breakpoints } from '../../../index'
import { SliderOnMobile } from '../slider/slider-on-mobile'

export interface BannersCarouselProps {
  title?: string
  description?: string
  items: DismissibleCardItem[]
  onRequestClose?: (banner: DismissibleCardItem) => void
}

export const BannersCarousel: FC<BannersCarouselProps> = ({
  title,
  description,
  items,
  onRequestClose,
}) =>
  items.length ? (
    <div className={classes.root}>
      {title && <h3 className={classes.title}>{title}</h3>}
      {description && <p className={classes.description}>{description}</p>}
      <SliderOnMobile
        options={{
          className: classes.slides,
          slidesPerView: 'auto',
          centeredSlides: false,
          enabled: false,
          watchOverflow: true,
          autoHeight: true,
          breakpoints: {
            0: {
              enabled: true,
              spaceBetween: 16,
            },
            [breakpoints['desktop-small']]: {
              enabled: false,
              spaceBetween: 16,
            },
          },
        }}
        navigation={false}
        pagination={false}
      >
        {items.map((item) => (
          <Tile {...item} onRequestClose={onRequestClose} key={item.itemId} />
        ))}
      </SliderOnMobile>
    </div>
  ) : null
